import styled from 'styled-components';

export const Input = styled.input``;

export const TextArea = styled.textarea``;

export const Label = styled.label`
  display: block;
  line-height: 1.2rem;
  padding: .3rem 0;
`;

export const ErrorMessage = styled.p``;
